export const version = "signing-key/5.2.0";
